import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import classnames from 'classnames';

import CloseIcon from '../icons/CloseIcon';

const stopPropagationEventHandler = e => {
  e.stopPropagation();
};

const NotificationModal = props => {
  if (!props.isOpen) {
    return null;
  }

  const closeModal = e => {
    e.preventDefault();
    props.close();
  };

  return ReactDOM.createPortal(
    <div className="modal-root" onClick={props.close}>
      <div
        onClick={stopPropagationEventHandler}
        className={classnames('modal-notification-container', { 'm-modal-notification-container': props.isMobile })}
      >
        <div className="modal-notification-header">
          <a href="#" onClick={closeModal}>
            <CloseIcon color="#131925" opacity={0.6} />
          </a>
        </div>
        <div className="modal-notification-body">
          {props.icon && <img src={props.icon} width={75} height={75} className="is-block" />}
          {props.header && <p className="modal-notification-caption">{props.header}</p>}
          {props.text && <p className="modal-notification-text">{props.text}</p>}
        </div>
      </div>
    </div>,
    document.getElementById('modal-root'),
  );
};

NotificationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  icon: PropTypes.string,
  header: PropTypes.string,
  text: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default NotificationModal;
